import ReactPaginate from 'react-paginate'

import * as S from './styles'

type PaginateProps = {
  handlePageClick: any
  pageCount: any
}

const Paginate = ({ handlePageClick, pageCount }: PaginateProps) => (
  <S.Wrapper>
    <ReactPaginate
      nextLabel=">"
      onPageChange={handlePageClick}
      pageRangeDisplayed={5}
      marginPagesDisplayed={2}
      pageCount={pageCount}
      previousLabel="<"
      pageClassName="page-item"
      pageLinkClassName="page-link"
      previousClassName="page-item"
      previousLinkClassName="page-link"
      nextClassName="page-item"
      nextLinkClassName="page-link"
      breakLabel="..."
      breakClassName="page-item"
      breakLinkClassName="page-link"
      containerClassName="pagination"
      activeClassName="active"
    />
  </S.Wrapper>
)

export default Paginate
